module.exports = __webpack_public_path__ + "img/dangerDodIcon.90192196.svg";